import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faSearch, faEnvelope, faBriefcase } from '@fortawesome/free-solid-svg-icons';

const fadeIn = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: 0.6 } }
};

const fadeInUp = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } }
};

const NotFound: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center py-16 px-4">
      <div className="container mx-auto max-w-4xl">
        <motion.div 
          initial="hidden"
          animate="visible"
          variants={fadeInUp}
          className="text-center"
        >
          <div className="relative mb-8 inline-block">
            <div className="absolute -inset-1 bg-gradient-to-r from-primary to-secondary rounded-lg opacity-75 blur"></div>
            <h1 className="relative text-9xl font-bold bg-white px-8 py-4 rounded-lg text-transparent bg-clip-text bg-gradient-to-r from-primary to-secondary">
              404
            </h1>
          </div>
          
          <motion.h2 
            variants={fadeIn} 
            className="text-3xl md:text-4xl font-bold text-gray-800 mb-6"
          >
            Page Not Found
          </motion.h2>
          
          <motion.p 
            variants={fadeIn}
            className="text-lg text-gray-600 mb-10 max-w-2xl mx-auto"
          >
            The page you are looking for might have been removed, had its name changed, 
            or is temporarily unavailable. Don't worry, we'll help you get back on track.
          </motion.p>

          <motion.div
            variants={fadeInUp}
            className="bg-white shadow-lg rounded-lg overflow-hidden mb-10"
          >
            <div className="bg-gradient-to-r from-primary/10 to-secondary/10 px-6 py-4">
              <h3 className="text-xl font-semibold text-gray-800">Popular Destinations</h3>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 p-6">
              <Link to="/" className="flex items-center p-3 bg-gray-50 hover:bg-primary/5 rounded-lg transition-colors duration-300">
                <FontAwesomeIcon icon={faHome} className="text-primary mr-3" />
                <span className="text-gray-700">Home Page</span>
              </Link>
              <Link to="/blog" className="flex items-center p-3 bg-gray-50 hover:bg-primary/5 rounded-lg transition-colors duration-300">
                <FontAwesomeIcon icon={faSearch} className="text-primary mr-3" />
                <span className="text-gray-700">Blog & Resources</span>
              </Link>
              <Link to="/services" className="flex items-center p-3 bg-gray-50 hover:bg-primary/5 rounded-lg transition-colors duration-300">
                <FontAwesomeIcon icon={faBriefcase} className="text-primary mr-3" />
                <span className="text-gray-700">Our Services</span>
              </Link>
              <Link to="/contact" className="flex items-center p-3 bg-gray-50 hover:bg-primary/5 rounded-lg transition-colors duration-300">
                <FontAwesomeIcon icon={faEnvelope} className="text-primary mr-3" />
                <span className="text-gray-700">Contact Us</span>
              </Link>
            </div>
          </motion.div>

          <motion.div variants={fadeInUp}>
            <Link 
              to="/" 
              className="btn bg-gradient-to-r from-primary to-secondary text-white hover:from-primary/90 hover:to-secondary/90 transition-all duration-300 px-8 py-3 rounded-lg font-medium"
            >
              Return to Homepage
            </Link>
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
};

export default NotFound; 